// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"snackbar_snackbar__SkA1o","CookieWarning__cookie":"snackbar_CookieWarning__cookie__1BvF_","close":"snackbar_close__3CTm7"};